import {createUuid} from './create-uuid.js';

export function createPmLoadTelemetry() {
    const attempts = [];
    return {
        start() {
            const record = {
                id: createUuid(),
                started_at_ms: Date.now(),
                elapsed_ms: null,
                http_status: null,
                text_status: null,
            };
            attempts.push(record);
            return {
                headers: record.id ? {'X-PM-Request-ID': record.id} : {},
                finish(status, textStatus) {
                    record.elapsed_ms = Date.now() - record.started_at_ms;
                    record.http_status = status;
                    record.text_status = textStatus;
                },
            };
        },
        snapshot() {
            return attempts.map((record) => ({...record}));
        },
    };
}
